<template>
  <div class="media">
    <div class="heading-3-bold popup-title" v-html="popup.sections.main.fields.value.title1"></div>
    <div class="paragraph-1 spacing" v-html="popup.sections.main.fields.value.text1"></div>
    <div class="heading-3-bold popup-title" v-html="popup.sections.main.fields.value.title2"></div>
    <div class="paragraph-1 spacing" v-html="popup.sections.main.fields.value.text2"></div>
    <div class="button-wrapper">
      <seu-button
        class="spacing"
        :button-link="popup.sections.main.fields.value.buttonLink1"
        :label="popup.sections.main.fields.value.buttonLabel1"
      />
    </div>
    <div class="heading-3-bold popup-title" v-html="popup.sections.main.fields.value.title3"></div>
    <div class="paragraph-1 spacing" v-html="popup.sections.main.fields.value.text3"></div>
    <div class="button-wrapper">
      <seu-button
        class="spacing"
        target="_blank"
        :button-link="popup.sections.main.fields.value.buttonLink2"
        :label="popup.sections.main.fields.value.buttonLabel2"
      />
    </div>
    <div class="heading-3-bold popup-title" v-html="popup.sections.main.fields.value.title4"></div>
    <div class="paragraph-1 spacing" v-html="popup.sections.main.fields.value.text4"></div>
    <div class="button-wrapper">
      <seu-button
        class="spacing"
        target="_blank"
        :button-link="popup.sections.main.fields.value.buttonLink3"
        :label="popup.sections.main.fields.value.buttonLabel3"
      />
    </div>
    <div class="heading-3-bold popup-title" v-html="popup.sections.main.fields.value.title5"></div>
    <div class="paragraph-1" v-html="popup.sections.main.fields.value.text5"></div>
    <div class="contact-member">
      <div class="lead-1" v-html="popup.sections.main.fields.value.memberName"></div>
      <a href="mailto:marco.quinter@seu.ch" class="paragraph-1"
         v-html="popup.sections.main.fields.value.memberEmail"></a>
      <a href="tel:+41 (0) 79 402 91 11" class="paragraph-1-link"
         v-html="popup.sections.main.fields.value.memberNumber"></a>
    </div>
    <div class="paragraph-1" v-html="popup.sections.main.fields.value.text6"></div>
  </div>
</template>

<script>
import SeuButton from "/seu-frontend/components/SeuButton";

export default {
  name: 'Media',
  components: {SeuButton},
  computed: {
    popup() {
      return require(`../../services/pages/${this.$store.state.currentLanguage.toLowerCase()}/media`).default;
    }
  },
}
</script>

<style lang="scss">
@import "Media.scss";
</style>
